import { DicaAjuda } from '@/ui/components/dica-ajuda';
import { type ClassificacaoDaNota } from '@fiscoai/contracts';

import { CLASSIFICACAO, CLASSIFICACAO_NOTA } from './rotulos';

const rotulo = (c: { classificacao: keyof typeof CLASSIFICACAO; personalizada: string | null }) =>
  c.personalizada ?? CLASSIFICACAO[c.classificacao];

/**
 * A classificação da nota na lista: vazia até todos os itens estarem classificados; a da empresa
 * pelo nome; a mista com a dica das classificações dos itens.
 */
export function ClassificacaoDaNotaCelula({
  classificacao,
  numero,
}: {
  classificacao: ClassificacaoDaNota | null;
  numero: string;
}) {
  if (!classificacao) return <span className="text-texto-fraco">—</span>;
  const nome = classificacao.personalizada?.nome ?? CLASSIFICACAO_NOTA[classificacao.tipo];
  if (classificacao.tipo !== 'MISTA') return <span className="text-sm">{nome}</span>;
  return (
    <span className="inline-flex items-center gap-1 text-sm">
      {nome}
      <DicaAjuda
        rotulo={`Classificações da nota ${String(Number(numero))}`}
        texto={classificacao.itens.map(rotulo).join(', ')}
      />
    </span>
  );
}
